import { createSlice } from '@reduxjs/toolkit';
import { filter } from 'lodash';
import { PATH_DASHBOARD } from '../../routes/paths';
import Axios from '../../utils/axiosInstance';

const initialState = {
  stockList: [],
  stock: null,
  stockIdData: [],
  stockId: null,
  stockLogList: [],
  stockCode: [],
  stockLog: null,
};

const slice = createSlice({
  name: 'stock',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setWorkshopId: (state, action) => {
      state.stockId = action.payload;
    },

    // DELETE Stock
    deleteStock(state, action) {
      const deleteStock = filter(state.stock, (stock) => stock.id !== action.payload);
      state.stock = deleteStock;
    },

    // GET Stock
    getStockListSuccess(state, action) {
      state.isLoading = false;
      state.stockList = action.payload;
    },

    // Create Stock
    createStock(state, action) {
      state.isLoading = false;
      state.stock = action.payload;
    },
    StockFindByID(state, action) {
      state.isLoading = false;
      state.stockIdData = action.payload;
    },
    // Create Stock Log
    createStockLog(state, action) {
      state.isLoading = false;
      state.stockLog = action.payload;
    },
    getStockLogListSuccess(state, action) {
      state.isLoading = false;
      state.stockLogList = action.payload;
    },
    stockCodeFind(state, action) {
      state.isLoading = false;
      state.stockCode = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { onToggleFollow, deleteStock } = slice.actions;

// ----------------------------------------------------------------------

export function dispatchDeleteStock(stockId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await Axios.delete(`/stocks/${stockId}`);
      dispatch(slice.actions.deleteStock(stockId));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function dispatchNewStock(stock, navigate) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.post('/stocks', stock);
      const { id, ...otherData } = response.data.data;

      dispatch(slice.actions.createStock(otherData));
      dispatch(slice.actions.setWorkshopId(id));

      navigate(`${PATH_DASHBOARD.stock.root}/${id}/view`);
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

// ----------------------------------------------------------------------

export function dispatchUpdateStock(stock) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.put(`/stocks/${stock.id}`, stock);
      dispatch(slice.actions.createStock(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getStockList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.get('/stocks');
      dispatch(slice.actions.getStockListSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------- Stock id find -------------------------------------

export function getStockFindByID(id) {
  return async (dispatch) => {
    if (!id) return;

    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.get(`/stocks/${id}`);
      dispatch(slice.actions.StockFindByID(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// -----------------------------Stock Log Create---------------------------------

export function dispatchNewStockLog(order_log) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.post('/stock-activities', order_log);
      dispatch(slice.actions.createStockLog(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// -----------------------------Stock Log Data ---------------------------------

export function getStockLogList(orderId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.get(`/stock-activities/${orderId}`);
      dispatch(slice.actions.getStockLogListSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// -----------------------------Stock manual code check ---------------------------------

export function getStockCodeFind(code, productId = null) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    const url = productId
      ? `/stocks/check-manual-code?code=${code}&productId=${productId}`
      : `/stocks/check-manual-code?code=${code}`;

    const response = await Axios.get(url);
    dispatch(slice.actions.stockCodeFind(response.data));
    return response.data; 
  };
}


